import { render, staticRenderFns } from "./UserIdMetadataEntry.vue?vue&type=template&id=753e9317"
import script from "./UserIdMetadataEntry.vue?vue&type=script&lang=js"
export * from "./UserIdMetadataEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports